'use client';

import { createOverlayStore } from '@/shared/stores/overlay';

const { open, OverlaySpace } = createOverlayStore();

export const popup = {
  open,
};

export const PopupSpace = OverlaySpace;
